import { GammaPageLayoutRoute } from '#pplx/frontend/apps/ask/spa/GammaPageLayoutRoute.js';
export const preloadGammaPageLayout = GammaPageLayoutRoute.preload;
//# sourceMappingURL=GammaPageLayoutRouteSupport.js.map